export enum OrderArticleTrackingDefectType {
  CLIENT_STAIN = 'CLIENT_STAIN',
  PROCESS_STAIN = 'PROCESS_STAIN',
  TEAR = 'TEAR',
  BURN = 'BURN',
  CREASE_DEFECT = 'CREASE_DEFECT',
  IMPROPER_FOLDING = 'IMPROPER_FOLDING',
  MISSING_LABEL = 'MISSING_LABEL',
  UNREADABLE_LABEL = 'UNREADABLE_LABEL',
  TORN_BLUE_BAG = 'TORN_BLUE_BAG',
  COLOR_BLEEDING = 'COLOR_BLEEDING',
  POOR_IRONING = 'POOR_IRONING',
  DAMP_ARTICLE = 'DAMP_ARTICLE',
  BILLING_ERROR = 'BILLING_ERROR',
  SHRINKAGE = 'SHRINKAGE',
  MISSING_DAMAGED_ACCESSORY = 'MISSING_DAMAGED_ACCESSORY',
  SENSITIVE_ARTICLE = 'SENSITIVE_ARTICLE',
}
